/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Open_Cli_ToolInputs */



/**
* | output |
* | --- |
* | "Open {name}" |
*
* @param {Open_Cli_ToolInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_cli_tool = /** @type {((inputs: Open_Cli_ToolInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_Cli_ToolInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ouvrir ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Öffnen Sie ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Aperto ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Открыть ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Abierto ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`打开${i?.name}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} を開く`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} खोलें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Abrir ${i?.name}`)
	return /** @type {LocalizedString} */ (`Open ${i?.name}`)
});